module.exports = __webpack_public_path__ + "static/media/LB-Design.33905c66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/LB-Design.jpg
// module id = 923
// module chunks = 0